// extracted by mini-css-extract-plugin
export default {"BlocRappel":"BlocRappel_BlocRappel__1pBlw","BlocTexte":"BlocRappel_BlocTexte__J-ewK"};